<ng-template [ngIf]="iframeLoaded">
    <iframe #iframe (load)="load(iframe)" width="100%" height="100%" frameBorder="0" [src]="urlSafe"
        *ngIf="sandbox == true && !allow" sandbox="allow-scripts allow-same-origin allow-popups"></iframe>
    <iframe #iframe (load)="load(iframe)" width="100%" height="100%" frameBorder="0" [src]="urlSafe"
        *ngIf="sandbox == false && !allow"></iframe>

    <iframe #iframe (load)="load(iframe)" width="100%" height="100%" frameBorder="0" [src]="urlSafe"
        *ngIf="sandbox == true && allow" allow="microphone; clipboard-read; clipboard-write"
        sandbox="allow-scripts allow-same-origin allow-popups"></iframe>
    <iframe #iframe (load)="load(iframe)" width="100%" height="100%" frameBorder="0" [src]="urlSafe"
        *ngIf="sandbox == false && allow" allow="microphone; clipboard-read; clipboard-write"></iframe>
</ng-template>
<nts-loader [isVisible]="!iframeLoaded"></nts-loader>